import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IOutageReplyIm } from '../outage-reply-im.model';
import { IOutageReplyVm } from '../outage-reply-vm.model';

@Injectable({ providedIn: 'root' })
export class OperatorOutageReplyService {
  private readonly baseUrl: string;

  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/OperatorOutageReply`;
  }

  post(outageReplyIm: IOutageReplyIm): Observable<IOutageReplyVm> {
    const headers = this.createHeaders();
    return this.http.post<IOutageReplyVm>(this.baseUrl, outageReplyIm, { headers });
  }

  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
